import type BaseEnumType from "@/app/services/baseEnumType";
import type Key from "@/app/types/common/key";
import type { Maybe } from "@/components/utils/typeHelpers";
import { keys } from "@/plugins/i18n";

export class EnumStopListItem implements BaseEnumType {
  private static allValues: EnumStopListItem[] = [];

  public static delivery = new EnumStopListItem(
    0,
    "delivery_app_delivery",
    keys.delivery_app_start_delivery,
    keys.delivery_app_edit_delivery,
    keys.delivery_app_complete_delivery,
    keys.delivery_app_unable_to_deliver
  );
  public static visit = new EnumStopListItem(
    1,
    "delivery_app_visit",
    keys.delivery_app_start_visit,
    keys.delivery_app_edit_visit,
    keys.delivery_app_complete_visit,
    keys.delivery_app_unable_to_visit
  );
  public static pickup = new EnumStopListItem(
    2,
    "delivery_app_pickup",
    keys.delivery_app_start_pickup,
    keys.delivery_app_edit_pickup,
    keys.delivery_app_complete_pickup,
    keys.delivery_app_unable_to_pickup
  );

  public key: number;
  public value: string;
  public startKey: Key;
  public editKey: Key;
  public completeKey: Key;
  public unableKey: Key;

  private constructor(
    key: number,
    value: string,
    startKey: Key,
    editKey: Key,
    completeKey: Key,
    unableKey: Key
  ) {
    this.key = key;
    this.value = value;
    this.startKey = startKey;
    this.editKey = editKey;
    this.completeKey = completeKey;
    this.unableKey = unableKey;
    EnumStopListItem.allValues.push(this);
  }

  public equals(other: Maybe<EnumStopListItem>): boolean {
    return this.key === other?.key;
  }

  public isDelivery() {
    return this.equals(EnumStopListItem.delivery);
  }
  public isPickup() {
    return this.equals(EnumStopListItem.pickup);
  }
  public isVisit() {
    return this.equals(EnumStopListItem.visit);
  }

  public static getValues(): EnumStopListItem[] {
    return EnumStopListItem.allValues;
  }

  public static getByKey(key: number): EnumStopListItem {
    const found = EnumStopListItem.allValues.find((e) => e.key === key);
    if (found === undefined) {
      throw new Error(`EnumStopListItem - Key not found: ${key}`);
    }

    return found;
  }
}
